export default __webpack_public_path__ + "static/media/AuthPoster.7055b12d.svg";